import MapEmbed from "../components/MapEmbed";
import ContactUs from "../components/Contact";
import ContactDetails from "../components/ContactDetails";

const ContactPage = () => {
    return (
        <section className="w-full py-12 px-6 bg-gray-100">
            <ContactDetails />
            <div className="container mx-auto flex flex-col md:flex-row gap-12 items-start">
                {/* Map on the left */}
                <div className="w-full md:w-1/2">
                    <ContactUs />
                </div>

                {/* Contact form on the right */}
                <div className="w-full md:w-1/2">
                    <MapEmbed />
                </div>
            </div>
        </section>
    );
};

export default ContactPage;
